import { render, staticRenderFns } from "./ShippingSelector.vue?vue&type=template&id=d7f7227e&scoped=true"
import script from "./ShippingSelector.vue?vue&type=script&lang=js"
export * from "./ShippingSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7f7227e",
  null
  
)

export default component.exports